// index.js

import initForms from './forms.js';
import initLeadSource from './lead-source.js';
import initNavigation from './navigation.js';
import initNewsletterSignup from './newsletter-signup.js';
import initPopup from './popup.js';
import initStackingCards from './stacking-card.js';
import initLandingPageForm from './landing-page-form.js';

document.addEventListener('DOMContentLoaded', () => {
    initLeadSource();
    initForms();
    initNavigation();
    initNewsletterSignup();
    initPopup();
    initStackingCards();
    initLandingPageForm();
});
